import Api from '../api.js'
import bus from '~/bus.js'
const state = {
  endpoint: '',
  page: 1,
  resultsPerPage: 40,
  totalElementsCount: 0,
  filterString: '',
  filterFields: [],
  sort: '',
  sortOrder: 'down',
  sortOptions: {},
  elements: [],
  guestAuth: '',
  lastLoadedPage: 0,
  cursor: ''
}

const getters = {
  firstElement: state => {
    return (state.page - 1) * state.resultsPerPage + 1
  },
  lastElement: state => {
    return (state.page - 1) * state.resultsPerPage + state.elements.length
  },
  isFirstPage: state => {
    return state.page === 1
  },
  isLastPage: state => {
    return state.lastLoadedPage >= Math.ceil(state.totalElementsCount / state.resultsPerPage) || state.totalElementsCount === 0
  },
  getIsLastPage: (state) => () => {
    return state.lastLoadedPage >= Math.ceil(state.totalElementsCount / state.resultsPerPage) || state.totalElementsCount === 0
  },
  isLastPageFull: state => {
    return state.elements.length > 0 && (state.elements.length % state.resultsPerPage) === 0
  },
  lastLoadedPage: state => {
    return state.lastLoadedPage
  },
  getlastLoadedPage: (state) => () => {
    return state.lastLoadedPage
  }
}

const mutations = {
  goToPage (state, page) {
    state.page = page || 1
  },
  guestAuth (state, guestAuth) {
    state.guestAuth = guestAuth
  },
  sort (state, sort) {
    state.sort = sort
  },
  sortOrder (state, order) {
    state.sortOrder = order
  },
  filter (state, filter) {
    state.filterString = filter.filterString
    state.filterFields = filter.filterFields
  },
  resultsPerPage (state, resultsPerPage) {
    state.resultsPerPage = resultsPerPage
  },
  totalElementsCount (state, totalElementsCount) {
    state.totalElementsCount = totalElementsCount
  },
  loadElements (state, elements) {
    state.elements = elements
  },
  clearElements (state) {
    state.elements = []
  },
  lastLoadedPage (state, page) {
    state.lastLoadedPage = page
  },
  setCursor (state, cursor) {
    state.cursor = cursor
    console.log('Cursor set to:', cursor, 'for endpoint:', state.endpoint, state.cursor)
  },
  clearCursor (state) {
    state.cursor = ''
  }
}

function getParamsFromState (state, payload) {
  let params = {
    count: state.resultsPerPage,
    page: state.page,
    cursor: state.cursor
  }

  if (payload && payload.filters && payload.filters.length > 0) {
    params.color_filter = payload.filters.slice()
    delete payload.filters
  }
  params = Object.assign(params, payload)

  if (state.filterString !== '') {
    params.filter = state.filterString
    params.fields = state.filterFields
  }
  if (state.sort !== '' && state.sort in state.sortOptions) {
    params.sort = state.sortOptions[state.sort].map(field => state.sortOrder === 'down'
      ? field
      : (
        field[0] === '-'
          ? field.slice(1)
          : '-' + field
      )
    )
  }
  params = { params }
  if (state.guestAuth) {
    params.headers = {
      Authorization: state.guestAuth
    }
  }
  return params
}

const actions = {
  goToPage ({commit}, page) {
    commit('goToPage', page)
  },
  guestAuth ({commit}, guestAuth) {
    commit('guestAuth', guestAuth)
  },
  sortBy ({commit}, sort) {
    if (typeof sort !== 'undefined' && typeof sort !== 'string') {
      console.warn('sort not string:', sort)
      commit('sort', sort[0])
    } else {
      commit('sort', sort)
    }
  },
  setSortOrder ({commit}, order) {
    commit('sortOrder', order)
  },
  resultsPerPage ({commit}, resultsPerPage) {
    commit('resultsPerPage', resultsPerPage)
  },
  filter ({commit}, filter) {
    commit('filter', filter)
  },
  loadElements ({ commit, state, dispatch, rootGetters }, payload) {
    const params = getParamsFromState(state, payload)

    let loadPromise
    if (rootGetters['filters/hasFilters']()) {
      const conf = {
        params: params && params.params ? params.params : {},
        data: rootGetters['filters/filters']()
      }
      loadPromise = Api.postV2('files/filter', conf)
    } else {
      loadPromise = Api.getV2(state.endpoint, params)
    }
    return loadPromise.then(response => {
      let newElements = response.body.results || []

      commit('loadElements', newElements)
      commit('totalElementsCount',
        typeof response.body.paginator === 'undefined'
          ? 0
          : response.body.paginator.result_total_count)
      bus.$emit('pageElementsLoaded', {
        elements: response.body.results || [],
        endpoint: state.endpoint,
        page: response.body.paginator ? response.body.paginator.current_page : 1
      })
      if (response.body.paginator) {
        commit('setCursor', response.body.paginator.cursor || '')
        commit('lastLoadedPage', response.body.paginator.current_page)
      }
      bus.$emit(state.endpoint + '/loadedElements', response.body.results || [])
      return response
    })
  },
  clearElements ({commit}) {
    commit('clearElements')
  },
  lastLoadedPage ({commit}, page) {
    commit('lastLoadedPage', page)
  },
  getNextElement ({state}, payload) {
    const params = getParamsFromState(state, payload)
    params.params.count = 1
    params.params.page = state.page * state.resultsPerPage + 1
    return Api.getV2(state.endpoint, params).then(response => (response.body.results || [null])[0])
  },
  clear ({commit}) {
    commit('clearCursor')
    commit('lastLoadedPage', 0)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/common/page.js